module.exports = __webpack_public_path__ + "static/media/RQ-icon.beae441c.gif";